import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { setInterval } from '@store/overviewDashboard/base/actions';
import { DatePicker } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import { isEqual } from 'lodash';
import { getLocalTime } from '@src/utils/tz';

const { RangePicker } = DatePicker;

const CustomDateRangePicker = ({
  value,
  setCustomSelected,
  isCustomSelected,
  overviewDate,
  tzOffset,
  containerRef,
}) => {
  const [rangeValue, setRangeValue] = useState([null, null]);
  const dispatch = useDispatch();
  const allowedDateMoment = moment(getLocalTime(overviewDate, tzOffset));

  const onRangeChange = (values: any) => {
    setRangeValue(values);
    if (values && !isEqual(value, values)) {
      const currentInterval = {
        from: moment(values[0]).startOf('day').format(),
        to: moment(values[1]).endOf('day').format(),
        shortcut: 'custom',
      };
      dispatch(setInterval({ interval: currentInterval }));
    }
    setCustomSelected(false);
  };

  const disableDates = (calendarDate) => {
    const calendarDateMoment = moment(calendarDate);
    return (
      moment().isBefore(calendarDateMoment) ||
      calendarDateMoment.isBefore(allowedDateMoment) ||
      calendarDateMoment.isBefore(moment().subtract(13, 'months').startOf('day'))
    );
  };

  useEffect(() => {
    if (Array.isArray(value)) {
      setRangeValue([value[0], value[1]]);
    }
  }, [value]);

  return (
    <div style={{ width: '240px' }}>
      <RangePicker
        value={rangeValue}
        separator={<ArrowRightOutlined />}
        disabledDate={disableDates}
        allowClear={false}
        onChange={onRangeChange}
        onOpenChange={(open) => setCustomSelected(open)}
        open={isCustomSelected}
        getPopupContainer={() => containerRef.current}
      />
    </div>
  );
};

export default CustomDateRangePicker;
